export default {
    methods: {
        api: (endpoint) => {
            if (endpoint.charAt(0) !== '/') {
                endpoint = '/' + endpoint
            }

            return process.env.VUE_APP_CARD_BACKEND + endpoint
        },
    }
}